import React from 'react'
import { useHistory } from 'react-router-dom'
import { ChevronRight as ChevronRightIcon } from 'react-feather'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { stringify } from 'query-string'
import { Box, Grid, IconButton, Typography } from '@material-ui/core'

import { DashboardChartPaper, DashboardTable, DonutChart } from 'components'

import theme from 'theme'
import helpers from 'helpers'

import { routes } from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'

const GeneralInformation = ({ isLoading = false, generalInformation }) => {
  const {
    GENERAL_INFORMATION_DEPARTMENTS_TABLE,
    GENERAL_INFORMATION_DATA_ORIGIN_TABLE,
    STORAGE_MODES_ORDER,
  } = constants.dataIntelligence
  const { CHOOSE_DATA_SOURCE_IDS } = constants.dataProcess

  const { snakeCase } = helpers.changeCase.keys

  const classes = useStyles()
  const history = useHistory()

  const storageTimes = snakeCase(generalInformation?.storageTimes) || {}

  const storageModeValues = STORAGE_MODES_ORDER.map(
    (mode) => storageTimes?.[mode] ?? 0,
  )

  const handleRedirect = (description) => {
    const sourceId = CHOOSE_DATA_SOURCE_IDS[description]

    const params = stringify(
      sourceId
        ? { sourceDescription: sourceId }
        : { anotherSourceDescription: description },
    )

    history.push(`${routes.dataProcess.all}?${params}`)
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Informações gerais
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhum departamento encontrado."
            rows={generalInformation?.departments}
            columns={GENERAL_INFORMATION_DEPARTMENTS_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Origem dos dados"
            subtitle="Acompanhe as informações sobre a origem dos dados"
            noMaxHeight
          >
            <DashboardTable
              emptyMessage="Nenhuma origem de dados encontrada."
              rows={generalInformation?.origins}
              columns={GENERAL_INFORMATION_DATA_ORIGIN_TABLE}
              isLoading={isLoading}
              renderAction={(row) => (
                <IconButton
                  size="small"
                  onClick={() => handleRedirect(row?.sourceDescription)}
                >
                  <ChevronRightIcon />
                </IconButton>
              )}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Tempo de armazenamento"
            subtitle="Processos conforme o tempo de armazenamento dos dados pessoais"
            isLoading={isLoading}
          >
            <DonutChart
              legendShow
              names={['Definido', 'Indefinido', 'Permanente']}
              values={storageModeValues}
              title="Tempo de armazenamento"
              colors={[
                theme.palette.dashboard.chart.primary.approved,
                theme.palette.dashboard.chart.primary.pending,
                theme.palette.grapePurple,
              ]}
              showName={false}
            />
          </DashboardChartPaper>
        </Grid>
      </Grid>
    </Box>
  )
}

GeneralInformation.propTypes = {
  isLoading: PropTypes.bool,
  generalInformation: PropTypes.object,
}

export default GeneralInformation
